import * as React from 'react';
import { Form } from 'react-final-form';
import { Field } from 'react-final-form';
import { translate } from 'components/translate-hoc';
import { getFieldValidators } from 'modules/additional-info-common/additional-info.validatiors';

import Button from 'components/button';

import { ITranslationProps } from 'types/translation';
import { IFieldRenderParams } from 'modules/additional-info-common/fields/fields.types';

import { TRANSLATE_PREFIX } from './additional-info-form.constants';
import { FIELD_VIEW_COMPONENTS, TEXT_SUB_KEYS } from 'modules/additional-info-common/additional-info.constants';

import 'modules/additional-info-common/fields/fields.styles.less';

export const AdditionalInfoForm: React.FC<IAdditionalInfoFormProps> = props => (
    <Form onSubmit={props.onSubmit}>
        {_props => {
            const { handleSubmit } = _props;
            const { dangerouslyTranslateWithHTML: translateKey } = props;
            const submitTranslate = translateKey(`${TRANSLATE_PREFIX}${TEXT_SUB_KEYS.SUBMIT}`);

            return (
                <form onSubmit={handleSubmit}>
                    {props.fields.map(field => {
                        const fieldValidators = getFieldValidators(field);

                        return (
                            <Field
                                key={field.name}
                                validate={fieldValidators}
                                name={field.name}
                                fieldValue={field.value}
                                translatePrefix={TRANSLATE_PREFIX}
                                activeLanguageCode={props.activeLanguageCode}
                                component={FIELD_VIEW_COMPONENTS[field.type]}
                            />
                        );
                    })}
                    <Button type="primary">
                        {submitTranslate}
                    </Button>
                </form>
            );
        }}
    </Form>
);

interface IAdditionalInfoFormProps extends ITranslationProps {
    readonly activeLanguageCode: string;
    readonly onSubmit: (values: object) => void;
    readonly fields: IFieldRenderParams[];
}

export default translate()(AdditionalInfoForm);
